import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 30000, // export için uzun timeout
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('avm_token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (err) => Promise.reject(err)
);

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      const isLoginRoute = err.config?.url?.includes('/auth/login');
      if (!isLoginRoute) {
        localStorage.removeItem('avm_token');
        localStorage.removeItem('avm_user');
        window.location.href = '/login?reason=session_expired';
      }
    }
    return Promise.reject(err);
  }
);

export const getErrorMessage = (err) => {
  if (err.response?.data?.message) return err.response.data.message;
  if (err.message === 'Network Error') return 'Sunucuya bağlanılamadı.';
  if (err.code === 'ECONNABORTED') return 'İstek zaman aşımına uğradı.';
  return 'Beklenmeyen bir hata oluştu.';
};

export default api;
